// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyStub__container___3l0Vx","image":"KeyStub__image___1U95y","title":"KeyStub__title___1dnpI","text":"KeyStub__text___1NlXC","button":"KeyStub__button___35T1D"};